// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__hZtlo","arrow":"Tooltip_arrow__4gpyP"};